import React, {memo} from 'react'
import _ from '/home/ps/root'
import { Ref, STAGE, setBlank, eId, promise, cache, Route, equal, copy, cookies} from '../../global'
import {tcp, go, dispatch, newRow} from '../../io'
// import {setBlank} from './table'
// import { usePark } from '../../hook/park'
import {Toast, toast} from '../master/toast'
import {sanitize} from './part/sanitize'
const ID = 'footer'
Ref[ID] = {}
const _footer_ = Ref[ID]
export const Footer = prop => {
  const { okI, orderI, lockI, owner, username, vid, uid, verb: _verb, connected, vendor, master, u, io, login, lang, cookie, route} = prop.master
  // const park = { ...prop.park }
  // const { park, setPark } = usePark()
  // const { extra = '' } = prop.body
  const extra = prop.body?.extra || ''
  const { pk, sell } = prop.table
  const { db: _db, v, setCart, park } = prop
  const select = Ref.online?.state?.select
  const _newRow = pk<0 || isNaN(pk)
  const newNotice = v=='notice' && _newRow
  const newPurchase = v == 'purchase' && _newRow
  // const verb = newNotice ? 'insert' : (prop.row ? prop.row.verb : _verb)
  const verb = newNotice ? 'insert' : (prop.row?.verb || _verb)
  const printer = park[v] && park[v][v=='login' ? verb : 'default']
  if (!printer) return null
  const {cfgRow, vendorRow} = prop.row
  // const db = newNotice ? vid : (connected ? IO.online.selected : _db)
  // const db = newNotice ? vid : (connected ? (IO.online.selected || vid) : _db)
  // const db = newNotice ? vid : (connected ? (IO.online.selected || vid) : _db)
  const db = newNotice ? vid : (connected ? (select || vid) : _db)
  // if (!db) debugger
  // if (!db) db = vid
  // console.log(ID, IO.online)
  const shard = newNotice ? vendor.home : (_.MASTER_.includes(v) ? cookie.p : cookie.home)
  const i = printer.part[v].i
  const stale = false
  // const cart = park[v][db].default[pk].json
  // if (!park.purchase[db]){console.log(IO.online);debugger}
  // const cart = park[v][db].default[pk].json
  const cart = park[v][db]?.default?.[pk]?.json || '[]'
  // if (park.purchase[db] && park.purchase[db].default){
  //   if (!park.purchase[db].default[pk]) {
  //     console.log(IO.online);debugger
  //   }
  // }
  // const cart = park.purchase[db] ? park.purchase[db].default[pk].json : '[]'
  const emptyCart = cart=='[]'
  const onCancel = e => {
    e.preventDefault()
    e.stopPropagation()
    console.log({[ID]: 'onCancel', db, v, pk, verb, Ref})
    const callbackCancel = stale => {
      if (!stale) return
      prop.setRow({stale: false})
      setTimeout(() => {
        console.log(prop.row?.fields)
        const db_ = newNotice ? _db : db
        const verb_ = newNotice ? _verb : verb
// if (!(Fields[db_]?.[v]?.[pk])) debugger
// if (!(prop.row?.fields[db_].getState()?.[v]?.[pk])) debugger
        // Object.keys(Fields[db_][v][pk][verb_]).forEach(id => Fields[db_][v][pk][verb_][id][''].init())
        Object.keys(prop.row?.fields).forEach( id => prop.row.fields[id].init())
        if (newNotice) {
          const blank = copy(prop.new)
          delete(blank[db_].notice)
          setBlank(blank)
          prop.action.new(blank)
        }
      }, 1)
    }
    if (prop.row.stale) Toast({content: [`Discard changes ?`], callback: r => {
      if (r) callbackCancel(true)
    }})
    callbackCancel(!prop.row.stale)
  }
  const onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    console.log({[ID]: 'onClick', db, v, pk, prop})
    if (window.opener && newRow && v=='purchase') window.close() // go shop
    const route = Route()
    // const purchaseDb = connected ? IO.online.selected : db
    const callback = status => {
      if (!status) return
      promise(({park, store}) => {
        const _vid = prop.row.vendorRow.id
        const npk = store.new[_vid]?.purchase
        const nrow = park[v][_vid].default?.[npk]
        const el = eId(`${_vid}${v}${npk}`)
        if (!el) return true
        el.scrollIntoView()
        // setCart(JSON.parse(park[v][db].default[pk].json), _vid, false, true)
        debugger
        // setCart(JSON.parse(cart), _vid, false, true)
        // setCart(JSON.parse(cart), _vid, false, false)
        // setCart(JSON.parse(cart), _vid, false)
        setCart({cart: JSON.parse(cart), db: _vid})
        prop.setRow({collapse: true})
      })
    } // callback
    let ok
    if (v=='purchase') {
      if (pk>0) {
        ok = true
        if (!(u=='store' && prop.row.vendorRow.username==route[1])) { // workaround
          ok = false
          const title = cfgRow ? prop.row.cfgRow.title : prop.row.vendorRow.username
          Toast({content: [`${master.go.i} ... ${title} ?`], callback: r => {
            if (r) {
              // go(prop.history.push, [lang, prop.row.vendorRow.username])
              go(prop.history.push, [prop.row.vendorRow.username])
              callback(true)
            }
          }})
        }
        callback(ok)
      }
      if (newRow) {
        setTimeout(() => prop.slide(ID, 'show'), 1)
        setTimeout(() => prop.slide('t', 'hide'), 1)
        setTimeout(() => prop.slide('l', 'hide'), 1)
        if (vid==_.QID) go(prop.history.push, [lang, prop.row.vendorRow.username, 'pay'])
      }
      return
    }
    if (sell && verb=='default') {
      const select = Ref.online?.state?.select
      const usr = Ref.store.getState().master.user[select] || STAGE[vid]
      // const usr = prop.user[select]
      console.log({ID, Ref, prop, db, _db, select, usr})
      // if (uid==vid) {
      if (owner) {
        if (connected) {
          if (!select) {
            // Toast({response: [master.ok.i], content: [`${master.select.i} ${master.customer.i}`]})
            toast(`${master.select.i} ${master.customer.i}`)
            return prop.slide('logo', 'hide')
          }
        // } else return Toast({response: [master.ok.i], content: [`Vendor cannot shop itself.`]})
        } else return toast(`Vendor cannot shop itself.`)
      }// else {
        // Row[vid].purchase[fpk].rowClick(fid, 'purchase', fpk, false, false)
      // }
      // if (uid==vid) return Toast({response: [master.ok.i], content: [`Vendor cannot shop itself.`]})
      // if (uid==vid && connected && !IO.online.selected) {
      //   Toast({response: [master.ok.i], content: [`${master.select.i} ${master.customer.i}`]})
      //   return prop.slide('logo', 'hide')
      //   // return
      // }
      // const test = Number(park[v][db].default[pk].test)
      const test = Number(park[v][vid].default[pk].test)
      if (test && !login) return Toast({response: [master.ok.i], content: [`${master[v].i} require login ...`]})
      // console.log({ID, db, _db, IO, prop})
      // return setCart([[pk, 1, park[v][vid].default[pk].price, v, '', true]], connected ? IO.online.state.select : _db)
      // const select = IO.online.state.select
      // const usr = prop.user[select]
      // if (usr?.lock) return Toast({response: [okI], content: [`${orderI} ${lockI}`]})
      if (usr?.lock) return toast(`${orderI} ${lockI}`)
      return setCart({cart: [[pk, 1, park[v][vid].default[pk].price, v, '', true]], db: connected ? Ref.online.state.select : _db})
      // return
    }
    let newNoticeRow
    if (v=='notice') {
      if (newRow) {
        setTimeout(() => prop.slide('l', 'hide'), 1)
        const newNoticePk = prop.new[uid][v]
        newNoticeRow = copy(park[v][uid].default[newNoticePk])
        // newNoticeRow.from = uid
        const type = newNoticeRow.type
        const newPurchasePk = prop.new[vid].purchase
        // const newPk = newNoticeRow.pk
        const blank = copy(prop.new)
        if (type=='purchase') {
          const key = `${lang}purchasenew`
          const pendingPurchase = cache(key) || {}
          const newPurchaseRow = copy(park.purchase[vid].default[newPurchasePk])
          // newNoticeRow.memo = prop.fields[v][uid].default[pk].memo.state.value
          // newNoticeRow.memo = Fields[uid][v][pk].default.memo[''].state.value
          newNoticeRow.memo = prop.row.fields.memo.getState().value
          pendingPurchase[newPurchasePk] = newPurchaseRow
          cache(key, pendingPurchase)
          delete(blank[vid].purchase)
          // Toast({response: [master.ok.i], content: [`${master.order.i} ${master.place.i} ${master.offline.i}`]})
          toast(`${master.order.i} ${master.place.i} ${master.offline.i}`)
        } else if (type=='follow') {
          // Toast({response: [master.ok.i], content: [`${master.new.i} ${master.vendor.i} ${master.follow.i}`]})
          toast(`${master.new.i} ${master.vendor.i} ${master.follow.i}`)
        }
        delete(blank[uid].notice)
        setBlank(blank)
      }
    }
    const callbackDef = name => {
      const row = park[v][db] && park[v][db].default[pk]
      if (v=='notice' && verb=='update' && row.type=='follow') {
        // go(prop.history.push, [lang, username, 'follow'])
        go(prop.history.push, [username, 'follow'])
        setTimeout(() => Ref.status.onNewRow('follow', {type:'follow', from: row.from, json: row.json}), 1111)
        return
      }
      const fields = Object.keys(printer.view.field).reduce((acc, id) => {
        if (id == v) return acc
        if (id == 'id') return acc
        acc.push(id)
        return acc
      }, [])
      // const Field = Fields[v=='login' ? 'user' : uid][v][pk][prop.ID=='state' ? verb : 'default']
      // const key = `${ v == 'login' ? 'user' : uid } ${ v } ${ pk } ${ prop.ID=='state' ? verb : 'default' }`
      // const Field = Ref.field[]//[v][pk][prop.ID=='state' ? verb : 'default']
      // const reqFields = v=='login' ? fields : fields.reverse()
      // if (v=='login' && !sanitize(prop, ID)) return
      // const required = v=='login' ? true : fields.reverse().reduce((acc, id) => {
      const required = v=='login' ? sanitize(prop, ID) : fields.reverse().reduce((acc, id) => {
// if (!Ref.field[`${ key } ${ id }${ extra }`]) debugger
        // const f = Ref.field[`${ key } ${ id }${ extra }`]?.state
        const f = prop.row.fields[id].getState()
if (!f) debugger
        if (f?.required && f?.value?.trim() == '') {
          // Toast({
          //   response: [master.ok.i],
          //   content: [`${master[id].i.l || master[id].i} required.`]
          // })
          toast(`${master[id].i.l || master[id].i} required.`)
          return false
        }
        return acc
      }, true)
      if (!required) return
      const stale = newNotice ? true : fields.reduce((acc, id) => {
        // acc |= Field[id]?.[''] ? Field[id][''].state.stale : false
// if (!Ref.field[`${ key } ${ id }${ extra }`]) debugger
        // const f = Ref.field[`${ key } ${ id }${ extra }`]?.state
        const f = prop.row.fields[id]?.getState()
if (!f) debugger
        // const f = Field[id]?.getState()
        acc |= f.stale
        return acc
      }, prop.row.stale)
      console.log({ fields: prop.row.fields, uid, db, v, pk, verb, stale})
      if (!stale && verb!=='delete') {
        console.log(`Footer.click !${stale} && ${verb}!==delete DELETE ...`)
        // Toast({
        //   response: [master.ok.i],
        //   content: [`Nothing to do.`]
        // })
        toast(`Nothing to do.`)
        return
      }
      switch (e.target.name || name) {
        case 'default':
        const data = fields.reduce((acc, id) => {
          if (id=='id' && (verb=='insert' || verb=='default')) return acc
// if (!Ref.field[`${ key } ${ id }${ extra }`]) debugger
          // const f = Ref.field[`${ key } ${ id }${ extra }`]?.state
          const f = prop.row.fields[id].getState()
  if (!f) debugger
        // let value = newNotice ? newNoticeRow[id] : Field[id]?.[''] ? (Field[id][''].state.value||'') : ''
          let value = newNotice ? newNoticeRow[id] : f.value
          // const json = Field[id]?.[''] ? Field[id][''].state.json : []
          const json = f.json
          let max
          const clone = verb=='insert' && pk>0
          switch (id) {
            // case 'medias':    value=JSON.stringify(value);    break
            // case 'lang':   debugger;    break
          case 'memo':     max = _.MEMO_M;
            value = f.value
          break
          case 'title':    max = _.TITLE_M;    break
          case 'desc':     max = _.DESC_M;     break
          case 'detail':   max = _.DETAIL_M;   break
          case 'name':     max = _.NAME_M;     break
          case 'username': max = _.USERNAME_M; break
          case 'password': max = _.PASSWORD_M; break
          // case 'memo':     max = _.MEMO_M;     value=Field[id][''].state.value;break
          case 'modified': value = Math.floor(Date.now()/1000); break
          case 'expire': value=row[id]; break
          case 'album': value = Ref.table.media.album; break
            // console.log({value, IO})
            // debugger
            // break
          case 'id': //value=pk; break
            _.USER_.includes(u) ? uid : pk
          break
          case 'selectmedia':
            value = json
          break
          case 'uri':
            if (verb=='update') value = row[id]
          break
          case 'reviews':
          case 'items':
          case 'medias':
if (typeof json=='undefined') debugger
            // value = JSON.stringify(json.map(el => el.pk))
            // value = JSON.stringify(json.map(el => el.src ? el.pk : ''))
            value = clone ? row[id] : JSON.stringify(json.reduce((acc, el, i) => {
              if (el.src) acc.push(Number(el.pk))
              return acc
            }, []))
          break
            // case 'expire':
            // case 'to':debugger
            // break
          case 'from': value=row && row.from ? row.from : uid; break
          case 'json':
            if (v=='follow') value=prop.row.follow ? JSON.stringify({follow: prop.row.follow}) : row.json
            else value = row.json
//            if (!prop.row.follow) debugger
            // if (v=='login') value='[]'
            // debugger
          break
          case 'rate':
            value = clone ? _.RATE_M : row[id]
          break
            // default:
            // if (_.JSON_[id]) value = Field[id].state.json// JSON.stringify(value)
          case 'map':
            // value = Field[id]?.[''] && JSON.stringify({...Field[id][''].state.value, map: 1})
            value = f && JSON.stringify({ ...f.value, map: 1 })
          break

          case 'remember':
            // value=Fields[db][v][pk][verb][id].state.value
            // value=Field[id][''].state.value
            value = f.value
            // break
          }
if (max && typeof value == 'undefined') debugger
          if (max) value = value.substring(0, max)
          // acc[id] = newNotice ? newNoticeRow[id] : prop.fields[v][db][verb][pk][id].state.value
          // if (Field[id]?.['']?.state?.stale) acc[id] = value
          if (f.stale) acc[id] = value
          return acc
        }, {})
        // const email = Ref.field[`${ key } email${extra}`]
        const email = prop.row.fields.email
        // if (v=='login' && (Field.email || row.email)) data.email = Field.email?.[''].state.value || row.email
        if (v=='login' && (email || row.email)) data.email = email ? email.getState().value : row.email
        console.log(`Footer.click DEF validate db${db} ${v} pk${pk} ${verb} ${prop.ref}, data`, data)
        // const buff = {debug: ID, type: 'request', lang, verb}
        const buff = {type: 'request', lang, verb}
        if (fields.includes('from') && row?.from) {debugger
          const from = cache(row.from)
          const found = from && from!=='find' && from.home!=_.ROOT // Q store
          buff.from = row.from
          // if (found && v=='follows' /*Gearman*/) tcp({...buff, db: row.from, v: 'follow', from: uid}, from.home)
          if (found && v=='follows' /*Gearman*/) tcp({...buff, db: row.from, v: 'follow', from: uid, home: from.home})
        }
        // if (v=='login' && !sanitize(prop, ID)) return
        console.log({...buff, request: data, db: v=='login' ? 'user' : db, v: v, pk: _.USER_.includes(u) ? uid : pk})
        // tcp({...buff, request: data, db: v=='login' ? 'user' : db, v: v, pk: _.USER_.includes(u) ? uid : pk}, shard, v=='login')
        // tcp({...buff, request: data, db: v=='login' ? 'user' : db, v, pk: _.USER_.includes(u) ? uid : pk}, shard, 1)
        tcp({...buff, request: data, db: v=='login' ? 'user' : db, v, pk: _.USER_.includes(u) ? uid : pk, home: v=='login'?_.ROOT:shard})
        if (v=='page' || v=='error') {
          prop.setRow({stale: false})
          // Object.keys(Field).forEach(f => Field[f][''].init())
          // fields.forEach(f => f.init())
          fields.forEach(id => prop.row.fields[id].init())
        }
        break
        case 'roll': console.log(`Footer.click ROLL db${db} ${v} pk${pk} ${verb}`); break
      }
    }
    const name = e.target.name
    if (v=='media' && newRow) {
      // const email = prop.row.fields.email
      // const selmedia = Fields[db][v][pk][verb]['selectmedia']['']
      const selectmedia = prop.row.fields.selectmedia
      const {title: _title, selected, value} = selectmedia.getState()
      if (_title) {
          Toast({content: [`Change ${value[selected].title} to ${_title} ?`], callback: r => {
            if (r) {//e.target changes inside toast
              value[selected].title = _title
              // Fields[db][v][pk][verb].title[''].setState({value:''})
              prop.row.fields.title.setState({ value: '' })
              selectmedia.setState({ value, title: '' }, console.log(prop.row.fields.selectmedia.getState()))
              callbackDef(name)
            }
          }})
      } else callbackDef(name)
    } else callbackDef(name)
  } // onClick
  let disabled = verb=='update' && v=='notice' ? false : (verb=='update' || verb=='insert') && !prop.row.stale
  if (v=='login') disabled = false
  if  (newPurchase && emptyCart) disabled=true
  let I = i.i
  if (newRow) {
    if (!sell) {
      switch (v) {
        case 'media': I = {default: master.upload.i}; break
        case 'login': break
        // case 'purchase': I = {default: newPurchase ? `${master.payment.i}` : `${master.go.i} ${master.shop.i}`}; break
        case 'purchase': I = {default: `${master.go.i} ${master.shop.i}`}; break
        case 'notice': I = {default: `${master.place.i} ${master.notice.i}`}; break
        case 'page': break
        case 'error': break
        default: I = {default: master[verb].i}
      }
    }
  } else if (verb!='default') {
    switch (v) {
      // case 'media': I = {default: master.upload.i}; break
      case 'login': break
      case 'purchase': break
      case 'notice': I = {default: verb=='update' ? master.reply.i : master[verb].i}; break
      default: I = {default: master[verb].i}
    }
  }
  if (sell && newRow) I = {default: `${master.insert.i}`}
  const footerClass = [v, `pk${pk}`]
  if (stale) footerClass.push('stale')
  // let disabled = verb=='update' && v=='notice' ? false : (verb=='update' || verb=='insert') && !prop.row.stale
  // if  (newPurchase && emptyCart) disabled=true
  const pdef =  {className: 'footer default theme', name: 'default',  onClick, /*key: `default${db}${v}${pk}${verb}`,*/ disabled}
  const proll = {className: 'footer roll theme', name: 'roll', onClick: onCancel/*, key: `roll${db}${v}${pk}${verb}`*/}
  const content= []//[__DEV__ ? 'footer' : '']
  const style = {margin: '10px'}
  // I && I.default  && content.push(<input type='button' {...pdef} style={style} value={I.default}/>)
  I?.default && content.push(<input type='button' {...pdef} key={`default${db}${v}${pk}${verb}`} style={style} value={I.default}/>)
  // content.push(<input type='button' {...pdef} style={style} value={I.default}/>)
  if (verb!='default' && v!='follows') content.push(<input type='button' {...proll} key={`roll${db}${v}${pk}${verb}`} disabled={!prop.row.stale} style={style} value={master.cancel.i}/>)
  footerClass.push('flex')
  const footerStyle = {
    justifyContent: 'center',
  }
  return (<div className={footerClass.join(' ')} style={footerStyle}> {!disabled && content} </div>)
}
export default Footer
